// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: UserAPI.CurrentUser;
  }>('/api/user/currentUser', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: UserAPI.LoginParams, options?: { [key: string]: any }) {
  // 使用formdata格式 提交数据
  const formData = new FormData();
  Object.keys(body).forEach((key) => {
    // @ts-ignore
    formData.append(key, body[key]);
  });

  return request<UserAPI.LoginResult>('/api/login/accessToken', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: formData,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<UserAPI.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<UserAPI.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<UserAPI.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<UserAPI.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

/** 选择登录身份 POST /api/login/selectIdentity */
export async function selectIdentity(body: { accessToken: string; pid: number }, options?: { [key: string]: any }) {
  return request<UserAPI.LoginResult>('/api/login/selectIdentity', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 短信验证码登录 POST /api/login/smsLogin */
export async function smsLogin(body: { phone: string; captcha: string }, options?: { [key: string]: any }) {
  return request<UserAPI.LoginResult>('/api/login/smsLogin', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 忘记密码 - 发送验证码 GET /api/login/forgotPassword/captcha */
export async function forgotPasswordCaptcha(params: { phone: string }, options?: { [key: string]: any }) {
  return request<any>('/api/login/forgotPassword/captcha', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 忘记密码 - 重置密码 POST /api/login/resetPassword */
export async function resetPassword(body: { phone: string; captcha: string; newPassword: string }, options?: { [key: string]: any }) {
  return request<any>('/api/login/resetPassword', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/**  GET /api/version */
export async function getVersion() {
  return request<{ version: string }>('/api/version', {
    method: 'GET',
  });
}
